import React from "react";
import { MobileInputText } from "@vernost_dev/vms-react-components/dist/MobileInputText";


const VmsMobileInputText = (props) => {
  const {
    onChange = () => { },
    type,
    onCountrydDropDownBlur= () => { },
    onMobileNoBlur= () => { },
    arrData,
    selectedValueFilterBy,
    selectedValue,
    inputlabel,
    msgText,
    value,
    messageMode,
    name,
    placeholder,
    selectedIndex,
    mobileNumber,
    customCountryList,
    label,
    onMobileNumberChange = () => { },
    onCountryChange = () => { },
    rightView,
    onCountryCodeSelect = () => { },
    showIsdCodeErrorMsgText,
    showMobileNoErrorMsgText,
    listItems,
    maxLength,
    isDropdownOpen,
    onCountryVisibilityChange = () => { },
    isdCodeErrorMsgText,
    defaultValue,
    disabled=false
  } = props;

  return (
    <MobileInputText
    arrData={arrData}
    onCountrydDropDownBlur={(e) => onCountrydDropDownBlur(e)}
    onMobileNoBlur={(e) => onMobileNoBlur(e)}
    selectedValueFilterBy={selectedValueFilterBy}
    selectedValue={selectedValue}
    disabled={disabled}
      value={value}
      messageMode={messageMode}
      msgText={msgText}
      inputlabel={inputlabel}
      onChange={(e) => onChange(e)}
      type={type}
      name={name}
      onMobileNumberChange={(val) => onMobileNumberChange(val)}
      placeholder={placeholder}
      selectedIndex={selectedIndex}
      onCountryChange={(code) => onCountryChange(code)}
      mobileNumber={mobileNumber}
      rightView={rightView}
      onCountryCodeSelect={(val, item) => onCountryCodeSelect(val, item)}
      showIsdCodeErrorMsgText={showIsdCodeErrorMsgText}
      showMobileNoErrorMsgText={showMobileNoErrorMsgText}
      listItems={listItems}
      label={label}
      maxLength={maxLength}
      isDropdownOpen={isDropdownOpen}
      onCountryVisibilityChange={(val) => onCountryVisibilityChange(val)}
      isdCodeErrorMsgText={isdCodeErrorMsgText}
      customCountryList={customCountryList}
      defaultValue={defaultValue}
    />
  );
};

export { VmsMobileInputText };
